import { useState, useEffect } from "react";
import { domain } from "config.js";

import style from "./style.module.scss";
import Item from "./Item";

function Properties() {

    const items = ["Mar-59", "Mar-57", "Est-80", "Mar-50"];
    const [itemImages, setItemImages] = useState([]);
    const [itemsData, setItemsData] = useState({});


    useEffect(() => {
        items.forEach(item=>getProperty(item));
    }, []);

    
    function getProperty(refNo){
        fetch(domain + "/int-search", { method: "POST", body: JSON.stringify({ref:refNo}) }).then(response => {
            response.json().then(result=>{
                const property = {};
                property[refNo] = result[0][refNo];

                setItemsData(oldData=>({...oldData, ...property}));
            });            
        });
    }

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.titlePart}>
                    <div>EIGENDOMMEN</div>
                    <div>TE KOOP</div>
                </div>

                <div className={style.propsContainer}>
                    {items.map((item, i)=><Item refNo={item} image={itemImages[item]} key={item} imagesState={{itemImages, setItemImages}} data={itemsData[item]}/>)}
                </div>
            </div>
        </div>
    );
}

export default Properties;